export default "__VITE_ASSET__c99def44__"